import { Component } from "@angular/core";
import { Configurations } from "../../core/configurations";

@Component({
  selector: 'public-confirm-expired-layout',
  moduleId: module.id,
  templateUrl: './public-confirm-expired-layout.component.html',
  styleUrls: ['./public-layout.component.css']
  
})

export class PublicConfirmExpiredLayoutComponent {
  
  isTest:boolean=Configurations.published?false:true;

  constructor(
    
  ) { 

  }
  codVersioneImg:string;
  pathImmagini:string=Configurations.baseUrl+"assets/imgs";

}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/layout/public-confirm-expired-layout.component.ts